import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { registerUser } from '../Auth.actions'
import JoinAccountFormComponent from './JoinAccountForm'

const formName = 'joinAccountForm'

const stateToProps = ({ auth: { allConfirmed } }) => ({
  allConfirmed,
  // option parameter from query string
  // special value will disable free/disposal email check
  option: window.location.search.slice(1), // remove '?' from query string
})

const dispatchToProps = {
  registerUser,
}

export default connect(
  stateToProps,
  dispatchToProps
)(reduxForm({ form: formName })(JoinAccountFormComponent))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccountForm/JoinAccountForm.container.js